import { Component, OnInit, OnDestroy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Subscription } from 'rxjs';
import {
  ModalService,
  ModalInstance,
} from '../../../core/services/modal.service';

@Component({
  selector: 'app-modal',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './modal.component.html',
})
export class ModalComponent implements OnInit, OnDestroy {
  modals: ModalInstance[] = [];
  private subscription: Subscription = new Subscription();

  constructor(private modalService: ModalService) {}

  ngOnInit(): void {
    this.subscription = this.modalService.getModals().subscribe((modals) => {
      this.modals = modals;
    });
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }

  closeModal(modalId: string): void {
    this.modalService.close(modalId);
  }

  onBackdropClick(event: Event, modalId: string): void {
    if (event.target === event.currentTarget) {
      this.closeModal(modalId);
    }
  }
}
